import React from 'react'
import { useStateContext } from 'provider/StateProvider'
import { getSinsuiDisplayValue } from 'common/utils'
import { RiskPanel } from 'components/RiskPanel'


export const KouzuiPanel = () => {
  const state = useStateContext()

  const content: string = React.useMemo(() => {
    const contents: string[] = []
    if (state.risks) {
      state.risks.forEach(c => {
        let name = c.name
        let value = c.value
        if ((name.startsWith('洪水浸水想定区域') || name.startsWith('浸水継続時間')) && value !== '') {
          if (name.startsWith('洪水浸水想定区域')) {
            name = name.replace('(想定最大)', '')
            value = getSinsuiDisplayValue(value)
          }
          contents.push(name + ': ' + value)
        }
      })
      // 家屋倒壊等
      const kaoku = state.risks?.find(r => r.name.startsWith('家屋倒壊等氾濫想定区域') && r.value !== '')
      if (kaoku !== undefined) {
        contents.push('家屋倒壊等氾濫想定区域: 区域内')
      }
    }

    if (contents.length === 0) {
      return '洪水浸水想定区域：区域外'
    } else {
      return contents.join('\n')
    }
  }, [state.risks])

  return (
    <>
      <RiskPanel title='洪水' content={content} backgroundColor='#b4e4f8' color='#37a9d8' />
    </>
  )
}
